import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveyRulesRPC } from "./getSurveyRulesRPC";

export class GetSurveyRulesRPCClientImpl extends GetSurveyRulesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveyRulesRPC.Request): Promise<LeoRPCResult<GetSurveyRulesRPC.Response, GetSurveyRulesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/GetSurveyRules",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveyRulesRPC.ResponseDTO,
      GetSurveyRulesRPC.Errors.ErrorsDTO,
      GetSurveyRulesRPC.Response,
      GetSurveyRulesRPC.Errors.Errors
    >(
      response,
      "survey-rules/GetSurveyRules",
      GetSurveyRulesRPC.Response.fromDTO,
      GetSurveyRulesRPC.Errors.fromDTO
    );
  }
}
